import React, { useEffect, useState } from "react";
import { useParams, useLocation } from "react-router-dom";
import axios from "axios";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import { useI18n } from "@/lib/i18n";

const BACKEND = process.env.REACT_APP_BACKEND_URL;

// Minimal markdown -> HTML (headers, bold, italic, links, lists, paragraphs).
// Intentionally tiny — no external deps.
function md(text) {
  if (!text) return "";
  const esc = (s) => s.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
  const lines = text.split("\n");
  const out = [];
  let inList = false;
  for (let raw of lines) {
    let line = esc(raw);
    if (/^### /.test(line)) { if (inList) { out.push("</ul>"); inList = false; } out.push(`<h3>${line.slice(4)}</h3>`); continue; }
    if (/^## /.test(line)) { if (inList) { out.push("</ul>"); inList = false; } out.push(`<h2>${line.slice(3)}</h2>`); continue; }
    if (/^# /.test(line)) { if (inList) { out.push("</ul>"); inList = false; } out.push(`<h1>${line.slice(2)}</h1>`); continue; }
    if (/^[-*] /.test(line)) {
      if (!inList) { out.push("<ul>"); inList = true; }
      out.push(`<li>${inline(line.slice(2))}</li>`);
      continue;
    }
    if (inList) { out.push("</ul>"); inList = false; }
    if (!line.trim()) { out.push(""); continue; }
    out.push(`<p>${inline(line)}</p>`);
  }
  if (inList) out.push("</ul>");
  return out.join("\n");
}
function inline(s) {
  return s
    .replace(/\*\*([^*]+)\*\*/g, "<strong>$1</strong>")
    .replace(/\*([^*]+)\*/g, "<em>$1</em>")
    .replace(/`([^`]+)`/g, "<code>$1</code>")
    .replace(/\[([^\]]+)\]\(([^)]+)\)/g, '<a href="$2" class="underline hover:text-[#002FA7]">$1</a>');
}

export default function Legal() {
  const params = useParams();
  const location = useLocation();
  const slug = params.slug || location.pathname.replace(/^\//, "").split("/").pop();
  const { lang } = useI18n();
  const [page, setPage] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    let cancelled = false;
    axios.get(`${BACKEND}/api/legal/${slug}`)
      .then((r) => { if (!cancelled) setPage(r.data); })
      .catch((e) => { if (!cancelled) setError(e?.response?.status === 404 ? "404" : "error"); });
    return () => { cancelled = true; };
  }, [slug]);

  if (error === "404") {
    return (
      <div className="App min-h-screen bg-background">
        <Header />
        <div className="mx-auto max-w-3xl px-4 py-24 text-center">
          <h1 className="font-display text-3xl font-black">404</h1>
          <p className="mt-2 text-muted-foreground">Page introuvable</p>
        </div>
        <Footer />
      </div>
    );
  }

  return (
    <div className="App min-h-screen bg-background" data-testid={`legal-${slug}`}>
      <Header />
      <main className="mx-auto max-w-3xl px-4 py-12 sm:px-6 lg:px-8">
        {page ? (
          <article
            className="prose prose-neutral max-w-none [&>h1]:font-display [&>h1]:text-3xl [&>h1]:font-black [&>h1]:tracking-tight [&>h1]:mb-6 [&>h2]:font-display [&>h2]:text-xl [&>h2]:font-bold [&>h2]:tracking-tight [&>h2]:mt-8 [&>h2]:mb-3 [&>h3]:font-display [&>h3]:text-base [&>h3]:font-bold [&>h3]:mt-4 [&>p]:text-sm [&>p]:leading-relaxed [&>p]:text-muted-foreground [&>p]:my-3 [&>ul]:my-3 [&>ul]:list-disc [&>ul]:pl-6 [&>ul]:text-sm [&>ul]:text-muted-foreground [&>ul>li]:my-1 [&>strong]:text-foreground"
            dangerouslySetInnerHTML={{ __html: md(lang === "en" ? page.body_en : page.body_fr) }}
          />
        ) : (
          <div className="font-mono text-sm text-muted-foreground">Chargement…</div>
        )}
      </main>
      <Footer />
    </div>
  );
}
